(function($){
    $.JumpOverlay = function() { 
        this._component_name = 'jump_overlay';
        this._query_selector = '.abdo-jump-overlay'; 
    };

    $.Component.create($.JumpOverlay, {
        _init_: function() {
            var jump_overlays  = document.querySelectorAll(this._query_selector); 
            for (var overlay_index = 0; overlay_index < jump_overlays.length; overlay_index++) { 
                var element = jump_overlays[overlay_index];
                if (!element.id) {
                    element.id = 'jump-overlay-' + overlay_index;
                }
                var location = ABDOUtil.getPointFromDataset(element);
                var rect = ABDOUtil.getRectFromDataset(element);
                var size = parseFloat(element.dataset.size);
                
                if (location != null && rect != null) {
                    var viewer = ABDOUtil.getViewer();
                    
                    if (viewer) {
                        this._create_jump_button(element, viewer, location, rect, size);

                        // if supports back to overlay button
                        if ("backX" in element.dataset) {
                            // original element, jump back location and size of the overlay
                            this._create_back_button(element, location, size); 
                        } 
                    }
                }
                
            }
        },

        _jump_button_click: function(viewer, rect) {
            viewer.viewport.fitBounds(rect, true);
    
            // if tracker disable scroll (to current location)
            if (abdo_osd.tracker) {
                abdo_osd.tracker.enableScroll(false);
            }

        },

        _create_jump_button: function(element, viewer, location, rect, size) {
            element.addEventListener(ABDOUtil.getClickHandler(element), this._jump_button_click.bind(this, viewer, rect));
            var overlay =  { 
                id: element.id,
                element: element,
                location: location,
                rotationMode: OpenSeadragon.OverlayRotationMode.NO_ROTATION,
                width: size,
                height: size 
            };
            this.parent._overlays.push(overlay);
            this.parent._add_overlay(overlay);
        },
            
        _create_back_button: function(element, jump_back, size) {
            var backX = parseFloat(element.dataset.backX);
            var backY = parseFloat(element.dataset.backY);
    
            var back_location = new OpenSeadragon.Point(backX, backY);
            var rect_offset = size*5;
            var back_rect = new OpenSeadragon.Rect(
                jump_back.x - rect_offset, jump_back.y - rect_offset,
                2*rect_offset, 2*rect_offset
            );
            var div = document.createElement('div');
            div.id = element.id  + '-back';
            div.className = element.className;
            div.classList.remove('abdo-jump-overlay');
            div.classList.add('abdo-jump-overlay-back');
            div.classList.add('abdo-overlay-nolink');
            // Object.assign(div.dataset, element.dataset);
    
            // add only as a reference, they are actually not needed
            div.setAttribute('data-back-x', backX);
            div.setAttribute('data-back-y', backY);
    
    
            var viewer = ABDOUtil.getViewer();
            if (viewer) {
                div.addEventListener(ABDOUtil.getClickHandler(div), function(evt) { 　
                    viewer.viewport.fitBounds(back_rect, true);
        
                    // if tracker disable scroll (to current location)
                    if (abdo_osd.tracker) {
                        abdo_osd.tracker.enableScroll(false);
                    }
                });
            } 

            var overlay =  { 
                id: element.id,
                element: div,
                className: element.className,
                location: back_location,
                rotationMode: OpenSeadragon.OverlayRotationMode.NO_ROTATION,
                width: size,
                height: size 
            };
            this.parent._overlays.push(overlay);
            this.parent._add_overlay(overlay);
        }
    }, $.Overlay);
})(ABDOMap); 